import { useQuery } from "react-query";
import { courseApiRequest } from "./client";
function fetchTccSnapshot(snapshotId) {
  return courseApiRequest({
    url: `/tcc/snapshot/${snapshotId}`,
    method: "GET"
  });
}
function useTccSnapshotQuery(snapshotId) {
  return useQuery(
    ["tcc", "snapshot", snapshotId],
    () => fetchTccSnapshot(snapshotId),
    { enabled: !!snapshotId }
  );
}
export {
  useTccSnapshotQuery
};
